import { Collapse, Radio, RadioGroup, Stack, Textarea } from '@chakra-ui/react';
import React, { useState } from 'react';
import { HiBadgeCheck, HiOutlineClipboardCopy, HiOutlineClipboardCheck } from 'react-icons/hi';
import { SqlContentEntity, TransportRequestScriptDB } from 'data/schemas/TransportRequest';

interface FileItemProps {
    scriptDB?: TransportRequestScriptDB;
    scriptDBs: TransportRequestScriptDB[];
    isShowLogs: boolean;
    isOpenConsole: boolean;
    onSelectedFile: (fileInfo: SqlContentEntity) => void;
    queryLogs: string[];
}

function FileItem(props: { isExpand: boolean; isShowLogs: boolean; content: string }) {
    const { isExpand, isShowLogs, content } = props;

    return (
        <Collapse
            in={isExpand}
            animateOpacity
        >
            {isShowLogs ? (
                <Textarea
                    value={'This is a Log'}
                    isReadOnly={true}
                    maxHeight={300}
                    rounded={0}
                />
            ) : (
                <Textarea
                    value={content}
                    isReadOnly={true}
                    maxHeight={300}
                    rounded={0}
                />
            )}
        </Collapse>
    );
}

function ScriptDBFileItem(props: FileItemProps) {
    const { scriptDBs, isShowLogs, isOpenConsole, onSelectedFile, queryLogs } = props;
    const [copiedIndex, setCopiedIndex] = useState<number | null>(null);

    const handleCopyToClipboard = async (content: string, index: number) => {
        try {
            await navigator.clipboard.writeText(content);
            setCopiedIndex(index);
            setTimeout(() => setCopiedIndex(null), 5000);
        } catch (err) {
            console.error('Failed to copy to clipboard:', err);
        }
    };

    const handleSelectedFile = (fileName: string) => {
        const scriptDB = scriptDBs.find(scriptDB => scriptDB.fileName === fileName);
        if (!scriptDB) {
            return;
        }

        onSelectedFile({
            file_name: scriptDB.fileName,
            s3_url: scriptDB.s3Url,
            status: scriptDB.status,
            mssql_version: 0
        });
    };

    const handleFindLog = (fileName: string) => {
        const foundLog = queryLogs.find(log => log.includes(fileName));

        if (!foundLog) {
            return 'No logs available for this file.';
        }

        return foundLog;
    };

    return (
        <React.Fragment>
            <RadioGroup
                name="select-file"
                onChange={value => handleSelectedFile(value)}
            >
                <Stack
                    spacing={1}
                    className="gap-2"
                >
                    {scriptDBs.map((scriptDB, index) => {
                        const status = scriptDB.status.toLowerCase();
                        return (
                            <div
                                key={index}
                                className="flex flex-col gap-0.5"
                            >
                                <div className="flex justify-between rounded border-2 border-neutral-950 bg-gradient-to-r from-cyan-300 to-teal-400 p-2">
                                    <div className="flex max-w-screen-md cursor-pointer items-center truncate">
                                        <Radio
                                            value={scriptDB.fileName}
                                            margin={0}
                                            padding={0}
                                            colorScheme="red"
                                            // borderColor="black"
                                        >
                                            <span className="font-bold">{scriptDB.fileName}</span>
                                        </Radio>
                                        {status === 'online' ? (
                                            <HiBadgeCheck
                                                color="green"
                                                size={20}
                                            />
                                        ) : status === 'error' ? (
                                            <HiBadgeCheck
                                                color="red"
                                                size={20}
                                            />
                                        ) : (
                                            <HiBadgeCheck size={20} />
                                        )}
                                    </div>
                                    <div
                                        className="flex cursor-pointer items-center"
                                        onClick={() =>
                                            handleCopyToClipboard(scriptDB.fileContent, index)
                                        }
                                        title={
                                            copiedIndex === index ? 'Copied!' : 'Copy to clipboard'
                                        }
                                    >
                                        {copiedIndex === index ? (
                                            <HiOutlineClipboardCheck
                                                size={25}
                                                color="green"
                                            />
                                        ) : (
                                            <HiOutlineClipboardCopy size={25} />
                                        )}
                                    </div>
                                </div>
                                {!isOpenConsole &&
                                    (isShowLogs ? (
                                        <Textarea
                                            value={handleFindLog(scriptDB.fileName)}
                                            isReadOnly={true}
                                            maxHeight={300}
                                            rounded={3}
                                            borderWidth={1}
                                            borderColor="gray"
                                        />
                                    ) : (
                                        <Textarea
                                            value={scriptDB.fileContent}
                                            isReadOnly={true}
                                            maxHeight={300}
                                            rounded={3}
                                            borderWidth={1}
                                            borderColor="gray"
                                        />
                                    ))}
                            </div>
                        );
                    })}
                </Stack>
            </RadioGroup>

            {/* Content File or Log */}
            {/*<FileItem
                isExpand={isExpand}
                isShowLogs={isShowLogs}
                content={selectedFile.fileContent}
            />*/}
        </React.Fragment>
    );
}

export default ScriptDBFileItem;
